enum EHorizontalProgressBarVariant {
    Light = "light",
    Dark = "dark"
}

export { EHorizontalProgressBarVariant }
